import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import { colors } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import i18next from "i18next";

const useStyles = makeStyles((theme) => ({
  table: {
    minWidth: 650,
  },
}));

export default function ShiftsReportTable(props) {
  const { data, title } = props;


  
  const { t } = useTranslation(["forms"]);
  const classes = useStyles();
  return (
    <TableContainer component={Paper}>
      <Table 
      //className={classes.table} 
      size="small" aria-label="a dense table">
        <TableHead>
          <TableRow
            style={{
              backgroundColor:colors.green[300],
              color: "#fff",
              textAlign: "-webkit-center",
              margin: "0px",
              whiteSpace: "nowrap",
              width: "0px",
              padding: "15px 0px",
              textAlign:"right"
            }}
          >
            <TableCell style={{ color: "#fff" ,textAlign:"right",fontWeight:"bold"}} align="center">
              {t("no")}
            </TableCell>
             <TableCell style={{ color: "#fff" ,textAlign:"right",fontWeight:"bold"}} align="center">
              {t("movement_type")}
            </TableCell>
            <TableCell style={{ color: "#fff" ,textAlign:"right",fontWeight:"bold"}} align="center">
              {t("number_of_invoices")}
            </TableCell>
            <TableCell style={{ color: "#fff" ,textAlign:"right",fontWeight:"bold"}} align="center">
              {t("total")}
            </TableCell>
            <TableCell style={{ color: "#fff" ,textAlign:"right",fontWeight:"bold"}} align="center">
              {t("cash2")}
            </TableCell>
            <TableCell style={{ color: "#fff" ,textAlign:"right",fontWeight:"bold"}} align="center">
              {t("foward")}
            </TableCell>
            <TableCell style={{ color: "#fff" ,textAlign:"right",fontWeight:"bold"}} align="center">
              {t("network")}
            </TableCell>
            <TableCell style={{ color: "#fff" ,textAlign:"right",fontWeight:"bold"}} align="center">
              {t("banks")}
            </TableCell>
            <TableCell style={{ color: "#fff" ,textAlign:"right",fontWeight:"bold"}} align="center">
              {t("dues")}
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((row,i) => (
            <TableRow key={row.title}
            style={{ padding: "5px 0px",
                textAlign: "-webkit-center",
                margin: "0px",
                whiteSpace: "nowrap",
                textAlign:"right"}}>
              <TableCell   style={{textAlign:"right",fontWeight:"bold"}} align="center">{i}</TableCell>
              <TableCell   style={{textAlign:"right",fontWeight:"bold"}} align="center">
                {i18next.language == "en-US" && row?.titleEn ? row.titleEn:row.title}</TableCell>
              <TableCell  style={{textAlign:"right",fontWeight:"bold"}} align="center" >{row.counts}</TableCell>
              <TableCell  style={{textAlign:"right",fontWeight:"bold"}} align="center" >{row.total?.toFixed(2)}</TableCell>
              <TableCell  style={{textAlign:"right",fontWeight:"bold"}} align="center" >{row.total_cash?.toFixed(2)}</TableCell>
              <TableCell  style={{textAlign:"right",fontWeight:"bold"}} align="center" >{row.total_agel?.toFixed(2)}</TableCell>
              <TableCell  style={{textAlign:"right",fontWeight:"bold"}} align="center" >{row.total_network?.toFixed(2)}</TableCell>
              <TableCell  style={{textAlign:"right",fontWeight:"bold"}} align="center" >{row.total_bank?.toFixed(2)}</TableCell>
              <TableCell  style={{textAlign:"right",fontWeight:"bold"}} align="center" >{row.total_emp?.toFixed(2)}</TableCell>

            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
